<table>
    <thead>
        <tr>
            <th class="subtable short"></th>
            <th class="subtable short">{{'global.pais' | translate }}</th>
            <th class="subtable short">{{'mantenimientoDenominaciones.paisDenominacion.etiquetasCaja' | translate }}</th>
            <th class="subtable short">{{'mantenimientoDenominaciones.paisDenominacion.etiquetasPallet' | translate }}</th>
            <th class="subtable short">{{'mantenimientoDenominaciones.paisDenominacion.imprimirDestino' | translate }}</th>
            <th class="subtable short">{{'mantenimientoDenominaciones.paisDenominacion.gestionIncidencias' | translate }}</th>
            <th class="subtable short">{{'mantenimientoDenominaciones.paisDenominacion.permisoLectura' | translate }}</th>
            <th class="subtable short">{{'mantenimientoDenominaciones.paisDenominacion.permisoConfeccion' | translate }}</th>
            <th class="subtable short">{{'mantenimientoDenominaciones.paisDenominacion.imprimirEtiquetaCaja' | translate }}</th>
            <th class="subtable short">{{'global.modoEtiqueta' | translate }}</th>
            <th class="subtable short">{{'global.modoCertificado' | translate }}</th>
            <th class="subtable actions">
                <i class="fas fa-plus" (click)="new=true;editables=''" title="{{'mantenimientoDenominaciones.paisDenominacion.tituloNew' | translate}}"></i>
            </th>
        </tr>
    </thead>
    <tbody>
        <app-pd-new-edit class="component-in-row" *ngIf="new" [editable]="true"
            [denominacionId]="this._denominacion.id" (close)="new=$event" (refresh)="refresh($event)"
            (editableChanged)="editableChanged($event)" (pushMessage)="pushMessage.emit($event)"
            [allGrupoEtiquetasCaja]="allGrupoEtiquetasCaja" [allGrupoEtiquetasPallet]="allGrupoEtiquetasPallet">
        </app-pd-new-edit>
        <app-pd-new-edit class="component-in-row" *ngFor="let paisDenominacion of listaPaises; let i = index;"
            [paisDenominacion]="paisDenominacion" [index]="i" [paisId]="paisDenominacion.paisId"
            [denominacionId]="paisDenominacion.denominacionId"
            [grupoEtiquetasCaja]="getGruposEtiqueta(paisDenominacion, 1)"
            [grupoEtiquetasPallet]="getGruposEtiqueta(paisDenominacion, 2)"
            [allGrupoEtiquetasCaja]="allGrupoEtiquetasCaja" [allGrupoEtiquetasPallet]="allGrupoEtiquetasPallet"
            [editable]="paisDenominacion === editables" (refresh)="refresh($event)"
            (editableChanged)="editableChanged($event)" (pushMessage)="pushMessage.emit($event)">
        </app-pd-new-edit>
    </tbody>
    <tfoot *ngIf="!listaPaises || (listaPaises && listaPaises.length < 1)">
        <tr>
            <td colspan="12">
                {{ 'global.noContent' | translate }}
            </td>
        </tr>
    </tfoot>
</table>
<app-paginator *ngIf="listaPaises && listaPaises.length > 0" [itemsPerPage]="itemsPerPage"
    [currentPage]="currentPage + 1" [totalItems]="totalItems" [visiblePages]="visiblePages"
    (pageChange)="pageChange($event)" (itemsPerPageChange)="itemsPerPageChange($event)"></app-paginator>
